<div class="shareTooltip">
  <a
    class="shareTooltips__btn shareTooltips__btn--twitter"
    href="{{ shareLinks.twitter }}"
    rel="noopener"
    target="_blank"
  >
    <img class="svg svg__twitter" src="/assets/svg/social-twitter.svg" alt="" />
  </a>
  <div
    class="shareTooltips__btn shareTooltips__btn--facebook fb-share-button"
    data-layout="button"
    data-size="large"
    data-mobile-iframe="true"
  >
    <a
      class="fb-xfbml-parse-ignore shareTooltips__link"
      href="{{ shareLinks.facebook }}"
      target="_blank"
      rel="noopener"
    >
      <img src="/assets/svg/social-facebook-logo.svg" class="svg svg__logoFacebook" alt="" />
    </a>
  </div>
  <a
    class="shareTooltips__btn shareTooltips__btn--tumblr"
    href="{{ shareLinks.tumblr }}"
    rel="noopener"
    target="_blank"
    data-posttype="'photo"
    [attr.data-content]="imgPath"
    [attr.data-caption]="product.name"
  >
    <img class="svg svg__logoTumblr" src="/assets/svg/social-tumblr.svg" alt="" />
  </a>
  <a
    href="{{ shareLinks.pinterest }}"
    class="shareTooltips__btn shareTooltips__btn--pinterest"
    rel="noopener"
    target="_blank"
  >
    <img class="svg svg__logoPinterest" src="/assets/svg/social-pinterest.svg" alt="" />
  </a>
  <a
    href="{{ shareLinks.google }}"
    class="shareTooltips__btn shareTooltips__btn--googleplus"
    rel="noopener"
    target="_blank"
  >
    <img class="svg svg__logoGoogle" src="/assets/svg/social-google.svg" alt="" />
  </a>
</div>
